import { render } from "./logoTitle.vue?vue&type=template&id=41e24806"
import script from "./logoTitle.vue?vue&type=script&lang=js"
export * from "./logoTitle.vue?vue&type=script&lang=js"

import "./logoTitle.vue?vue&type=style&index=0&id=41e24806&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__